import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-buttons',
  templateUrl: './form-buttons.component.html',
  styleUrls: ['./form-buttons.component.scss']
})
export class FormButtonsComponent implements OnInit {

  @Input() submitting = false;
  @Input() disabled = false;
  @Input() icons = true;
  @Input() submitLabel: string = null;
  @Input() cancelLabel: string = null;
  @Input() cancelHidden = false;
  @Output() cancelled = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onCancel(): void {
    if (this.cancelHidden !== true) {
      this.cancelled.emit();
    }
  }

}
